/* eslint-disable import/no-cycle */
import {getAgentSignature} from '../../helpers/getAgentSignature';
import {QuoteTemplateParams} from '../quoteTemplateParams';
import {
    emailHeaderCompanyLogo,
    quoteGreeting,
    quoteDiscussionReview,
    quoteIntroVideo,
    aboutAmplify,
} from '../../helpers/commonEmailComponents';

export default function quoteGINonblend(params: QuoteTemplateParams) {
    // eslint-disable-next-line
    const {name, face_amount: faceAmount, monthly_premium: monthlyPremium} = params;

    return `
${emailHeaderCompanyLogo}
<p>Hi ${highlightYellow(name)},</p>
${quoteGreeting}
${quoteDiscussionReview}
${quoteIntroVideo}
<p><strong>Our life insurance policies provide:</strong></p>
<ol>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">Coverage that lasts for the rest of your life</span></li>
</ol>
<p><strong>Life insurance plan option for ${highlightYellow(name)}</strong></p>
<ul>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">${highlightYellow(
        faceAmount,
    )}</span><span style="font-weight: 400;"> life insurance protection for the rest of life&nbsp;</span></li>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">${highlightYellow(
        monthlyPremium,
    )} per month</span></li>
</ul>
<p><span style="text-decoration: underline; font-weight: 400;"><strong>Next steps</strong></span></p>
<ol>
<li style="font-weight: 400;" aria-level="1"><strong>Decision</strong><span style="font-weight: 400;"> - You can choose to accept, change, or deny the offer</span></li>
<li style="font-weight: 400;" aria-level="1"><strong>Protection</strong><span style="font-weight: 400;"> - You are protected! You can change your monthly premiums, review policy details, and access your tax-free cash all in your online portal at any time</span></li>
</ol>
${aboutAmplify}
<p><span style="font-weight: 400;">Please let me know if you have any additional questions. Otherwise looking forward to speaking with you again </span><span style="font-weight: 400;">${highlightYellow(
        'on Friday',
    )}</span><span style="font-weight: 400;"> to help you find a plan that best fits your needs.</span></p>
<p><span style="font-weight: 400;">Sincerely,</span></p>
${getAgentSignature()}
	`;
}

export type quoteGINonblendParams = {
    name: string;
    face_amount: number | string;
    monthly_premium: number | string;
};

function highlightYellow(s: string | number) {
    return `<span class="wrapper" style="background-color: rgb(241, 196, 15);" data-mce-style="background-color: #f1c40f;">${s}</span>`;
}
